up.compiler('[data-gtm-data-layer-push]', el => {
  if (window.mymallsMeasurementOwnsEvents) return
  let {gtmDataLayerPush, ...data} = el.dataset
  // console.log('[] => Sending to dataLayer', data);
  window.dataLayer.push({...data});
})
